import { useState, useEffect } from "react";
import { ethers } from "ethers";
import { contractAbi, contractAddress } from "./Constant/constant";
import Login from "./Components/Login";
import Connected from "./Components/Connected";
import "./App.css";

function App() {
	const [provider, setProvider] = useState(null);
	const [account, setAccount] = useState(null);
	const [isConnected, setIsConnected] = useState(false);
	const [votingStatus, setVotingStatus] = useState(true);
	const [remainingTime, setremainingTime] = useState("");
	const [candidates, setCandidates] = useState([]);
	const [CanVote, setCanVote] = useState(false);

	useEffect(() => {
		getCandidates();
		getRemainingTime();
		getCurrentStatus();
		if (window.ethereum) {
			window.ethereum.on("accountsChanged", handleAccountsChanged);
		}

		return () => {
			if (window.ethereum) {
				window.ethereum.removeListener(
					"accountsChanged",
					handleAccountsChanged
				);
			}
		};
	}, []);

	async function vote(index) {
		const provider = new ethers.providers.Web3Provider(window.ethereum);
		await provider.send("eth_requestAccounts", []);
		const signer = provider.getSigner();
		const contractInstance = new ethers.Contract(
			contractAddress,
			contractAbi,
			signer
		);

		const tx = await contractInstance.vote(index);
		await tx.wait();
		canVote();
	}

	async function canVote() {
		const provider = new ethers.providers.Web3Provider(window.ethereum);
		await provider.send("eth_requestAccounts", []);
		const signer = provider.getSigner();
		const contractInstance = new ethers.Contract(
			contractAddress,
			contractAbi,
			signer
		);
		const voteStatus = await contractInstance.voters(
			await signer.getAddress()
		);
		setCanVote(voteStatus);
	}

	async function getCandidates() {
		const provider = new ethers.providers.Web3Provider(window.ethereum);
		await provider.send("eth_requestAccounts", []);
		const signer = provider.getSigner();
		const contractInstance = new ethers.Contract(
			contractAddress,
			contractAbi,
			signer
		);
		const candidatesList = await contractInstance.getAllVotesOfCandiates();
		const formattedCandidates = candidatesList.map((candidate, index) => {
			console.log(candidate);
			return {
				index: index,
				name: candidate.name,
				voteCount: candidate.voteCount.toNumber(),
			};
		});
		console.log("candidatesList", candidatesList, formattedCandidates);
		setCandidates(formattedCandidates);
	}

	async function getCurrentStatus() {
		const provider = new ethers.providers.Web3Provider(window.ethereum);
		await provider.send("eth_requestAccounts", []);
		const signer = provider.getSigner();
		const contractInstance = new ethers.Contract(
			contractAddress,
			contractAbi,
			signer
		);
		const status = await contractInstance.getVotingStatus();
		console.log(status);
		setVotingStatus(status);
	}

	async function getRemainingTime() {
		const provider = new ethers.providers.Web3Provider(window.ethereum);
		await provider.send("eth_requestAccounts", []);
		const signer = provider.getSigner();
		const contractInstance = new ethers.Contract(
			contractAddress,
			contractAbi,
			signer
		);
		const time = await contractInstance.getRemainingTime();
		console.log("time", time);
		setremainingTime(parseInt(time, 16));
	}

	function handleAccountsChanged(accounts) {
		if (accounts.length > 0 && account !== accounts[0]) {
			setAccount(accounts[0]);
			canVote();
		} else {
			setIsConnected(false);
			setAccount(null);
		}
	}

	async function connectToMetamask() {
		if (window.ethereum) {
			try {
				const provider = new ethers.providers.Web3Provider(
					window.ethereum
				);
				setProvider(provider);
				await provider.send("eth_requestAccounts", []);
				const signer = provider.getSigner();
				const address = await signer.getAddress();
				setAccount(address);
				console.log("Metamask Connected : " + address);
				setIsConnected(true);
				canVote();
			} catch (err) {
				console.error(err);
			}
		} else {
			console.error("Metamask is not detected in the browser");
		}
	}

	return (
		<div className="App">
			{isConnected ? (
				<Connected
					account={account}
					candidates={candidates}
					remainingTime={remainingTime}
					voteFunction={vote}
					showButton={CanVote}
					votingStatus={votingStatus}
				/>
			) : (
				<Login connectWallet={connectToMetamask} />
			)}
		</div>
	);
}

export default App;
